module.exports = __webpack_public_path__ + "static/media/lifebuoy.0eb64fd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/lifebuoy.png
// module id = 953
// module chunks = 0